export default function formatUTCDate(date: string | unknown, dateStringLength: number = 19): string {
  if (date instanceof Date) {
    return date.toISOString().slice(0, dateStringLength)
  }

  if (typeof date !== 'string' || date === 'null') {
    return ''
  }

  const normalizedDate = date.includes('T') ? date + 'Z' : date + ' UTC'
  const finalDate = new Date(normalizedDate)
  return finalDate.toISOString().slice(0, dateStringLength)
}
